export class PlandataTimeLineInfo {
  plantitle: string = "";
  plantitle_en: string = "";
  plantype: string = "";
  planConsultationStart: string = "";
  planConsultationEnd: string = "";
  planApprovedeffEctiveDate: string = "";
  planCancelDate: string = "";
}
